import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '../store/auth-context';

export const useRedirectIfLoggedIn = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  if (auth.isLoggedIn) {
    history.push('/');
  }
};
